import { combineReducers } from "@reduxjs/toolkit";
import getSchemaReducer from "./get-schema";

const schemaReducer = combineReducers({
  schema: getSchemaReducer
});

export default schemaReducer;